import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { environmentActions } from 'store/sagas/environment/environment.action';
import { environmentSelectors } from 'store/slices/environment/selector';
import PageLoader from 'components/PageLoader/PageLoader';

interface Props {
  children: React.ReactNode;
}

export const ProviderEnvironment = ({ children }: Props) => {
  const dispatch = useDispatch();
  const environment = useSelector(environmentSelectors.environment);

  useEffect(() => {
    dispatch(environmentActions.initEnvironment());
  }, []);

  if (!Object.keys(environment).length) {
    return <PageLoader />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
